export function videoFirstFrameSource(url) {
  const source = String(url || '').trim();
  if (!source || source.startsWith('preview://')) return source;
  return `${source.split('#')[0]}#t=0.001`;
}
